import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
import { riseIn } from '../motion';

interface Props {
  title?: string;
  count?: number;
  action?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

/** 見出し＋中身のまとまり。全画面で同じ形。 */
export const Section: React.FC<Props> = ({ title, count, action, children, className }) => (
  <motion.section className={['v2-section', className].filter(Boolean).join(' ')} variants={riseIn}>
    {(title || action) && (
      <div className="v2-section-head">
        {title && (
          <h2 className="v2-section-title">
            {title}
            {count !== undefined && <span className="v2-count">{count}</span>}
          </h2>
        )}
        {action}
      </div>
    )}
    {children}
  </motion.section>
);

/** 見出しの右に置く「すべて」などの移動リンク */
export const MoreLink: React.FC<{ onClick: () => void; children: React.ReactNode }> = ({ onClick, children }) => (
  <motion.button className="v2-link" onClick={onClick} whileHover="hover">
    {children}
    <motion.span variants={{ hover: { x: 3 } }} style={{ display: 'grid' }}>
      <ChevronRight size={16} />
    </motion.span>
  </motion.button>
);
